import type { RecordingDetails } from "../openapi-aliases";

export const recordingPipelineGeneration: RecordingDetails = {
  id: "00068000-11fb-8302-aaaa-cccccccccccc",
  user_id: "00068000-11fb-8302-8c10-1a913601212b",
  name: "Pipeline generation",
  date_started: "2026-07-29T11:00:00.375",
  date_ended: "2026-07-29T11:14:30.772",
  relative_path_on_disk: "recording_2026-07-29_11_00_00",
  status: {
    status: "completed",
    result: {
      startTimestamp: 1785315600,
      endTimestamp: 1785316470,
      durationSeconds: 870,
      nodes: [
        {
          id: 5001,
          depth: 2,
          name: "review-assigned-lead",
          goal: "Open Salesforce and review the assigned lead before beginning outreach.",
          attributes: [
            {
              name: "app.Salesforce.duration_s",
              value: 35.0,
            },
            {
              name: "screenshots",
              value: ["2026-07-29_09_00_04_000.png", "2026-07-29_09_00_29_000.png"],
            },
          ],
          relationships: [
            {
              object: "Lead A",
              qualifier: "reviewed",
            },
          ],
          coverage: [["2026-07-29T09:00:00Z", "2026-07-29T09:00:35Z"]],
          duration_s: 35.0,
        },
        {
          id: 5002,
          depth: 2,
          name: "qualify-prospect",
          goal: "Open LinkedIn and verify Prospect A's VP Operations role, executive seniority, and the company's recent expansion of its European distribution network.",
          attributes: [
            {
              name: "app.LinkedIn.duration_s",
              value: 55.0,
            },
            {
              name: "screenshots",
              value: ["2026-07-29_09_00_42_000.png", "2026-07-29_09_01_18_000.png"],
            },
          ],
          relationships: [
            {
              object: "Prospect A",
              qualifier: "qualified",
            },
            {
              object: "Company Alpha",
              qualifier: "researched",
            },
          ],
          coverage: [["2026-07-29T09:00:35Z", "2026-07-29T09:01:30Z"]],
          duration_s: 55.0,
        },
        {
          id: 5003,
          depth: 2,
          name: "open-template-library",
          goal: "Open the personal outreach template document.",
          attributes: [
            {
              name: "app.Google Docs.duration_s",
              value: 20.0,
            },
            {
              name: "screenshots",
              value: ["2026-07-29_09_01_36_000.png"],
            },
          ],
          relationships: [
            {
              object: "Personal Outreach Playbook",
              qualifier: "opened",
            },
          ],
          coverage: [["2026-07-29T09:01:30Z", "2026-07-29T09:01:50Z"]],
          duration_s: 20.0,
        },
        {
          id: 5004,
          depth: 2,
          name: "select-outreach-template",
          goal: "Locate and select the 'VP Operations — first outreach' template.",
          attributes: [
            {
              name: "app.Google Docs.duration_s",
              value: 20.0,
            },
            {
              name: "screenshots",
              value: ["2026-07-29_09_01_56_000.png", "2026-07-29_09_02_05_000.png"],
            },
          ],
          relationships: [
            {
              object: "VP Operations — first outreach",
              qualifier: "selected",
            },
          ],
          coverage: [["2026-07-29T09:01:50Z", "2026-07-29T09:02:10Z"]],
          duration_s: 20.0,
        },
        {
          id: 5005,
          depth: 2,
          name: "copy-template-to-draft",
          goal: "Copy the selected template from the document into a new Gmail draft.",
          attributes: [
            {
              name: "app.Google Docs.duration_s",
              value: 7.0,
            },
            {
              name: "app.Gmail.duration_s",
              value: 13.0,
            },
            {
              name: "screenshots",
              value: ["2026-07-29_09_02_13_000.png", "2026-07-29_09_02_25_000.png"],
            },
          ],
          relationships: [
            {
              object: "VP Operations — first outreach",
              qualifier: "copied-to-gmail",
            },
          ],
          coverage: [["2026-07-29T09:02:10Z", "2026-07-29T09:02:30Z"]],
          duration_s: 20.0,
        },
        {
          id: 5006,
          depth: 2,
          name: "personalize-template",
          goal: "Replace the prospect name, company name, and one sentence with the verified context about Company Alpha's European distribution expansion.",
          attributes: [
            {
              name: "app.Gmail.duration_s",
              value: 85.0,
            },
            {
              name: "screenshots",
              value: [
                "2026-07-29_09_02_44_000.png",
                "2026-07-29_09_03_24_000.png",
                "2026-07-29_09_03_49_000.png",
              ],
            },
          ],
          relationships: [
            {
              object: "Prospect A",
              qualifier: "personalized",
            },
            {
              object: "Company Alpha",
              qualifier: "personalized",
            },
          ],
          coverage: [["2026-07-29T09:02:30Z", "2026-07-29T09:03:55Z"]],
          duration_s: 85.0,
        },
        {
          id: 5007,
          depth: 2,
          name: "review-and-send-email",
          goal: "Quickly reread the personalized first-outreach email and send it to Prospect A.",
          attributes: [
            {
              name: "app.Gmail.duration_s",
              value: 50.0,
            },
            {
              name: "screenshots",
              value: ["2026-07-29_09_04_05_000.png", "2026-07-29_09_04_39_000.png"],
            },
          ],
          relationships: [
            {
              object: "Prospect A",
              qualifier: "emailed",
            },
          ],
          coverage: [["2026-07-29T09:03:55Z", "2026-07-29T09:04:45Z"]],
          duration_s: 50.0,
        },
        {
          id: 5008,
          depth: 2,
          name: "review-assigned-lead",
          goal: "Open Salesforce and review the next assigned lead.",
          attributes: [
            {
              name: "app.Salesforce.duration_s",
              value: 30.0,
            },
            {
              name: "screenshots",
              value: ["2026-07-29_09_05_20_000.png", "2026-07-29_09_05_39_000.png"],
            },
          ],
          relationships: [
            {
              object: "Lead B",
              qualifier: "reviewed",
            },
          ],
          coverage: [["2026-07-29T09:05:15Z", "2026-07-29T09:05:45Z"]],
          duration_s: 30.0,
        },
        {
          id: 5009,
          depth: 2,
          name: "research-prospect-and-company",
          goal: "Open LinkedIn and read Prospect B's VP Operations profile and Company Beta's overview.",
          attributes: [
            {
              name: "app.LinkedIn.duration_s",
              value: 70.0,
            },
            {
              name: "screenshots",
              value: [
                "2026-07-29_09_05_54_000.png",
                "2026-07-29_09_06_31_000.png",
                "2026-07-29_09_06_49_000.png",
              ],
            },
          ],
          relationships: [
            {
              object: "Prospect B",
              qualifier: "researched",
            },
            {
              object: "Company Beta",
              qualifier: "researched",
            },
          ],
          coverage: [["2026-07-29T09:05:45Z", "2026-07-29T09:06:55Z"]],
          duration_s: 70.0,
        },
        {
          id: 5010,
          depth: 2,
          name: "search-previous-outreach",
          goal: "Search Gmail for a similar email previously sent to Prospect C, an Operations Manager at another company.",
          attributes: [
            {
              name: "app.Gmail.duration_s",
              value: 70.0,
            },
            {
              name: "screenshots",
              value: [
                "2026-07-29_09_07_08_000.png",
                "2026-07-29_09_07_44_000.png",
                "2026-07-29_09_08_00_000.png",
              ],
            },
          ],
          relationships: [
            {
              object: "Prospect C",
              qualifier: "previous-email-found",
            },
          ],
          coverage: [["2026-07-29T09:06:55Z", "2026-07-29T09:08:05Z"]],
          duration_s: 70.0,
        },
        {
          id: 5011,
          depth: 2,
          name: "copy-previous-email",
          goal: "Copy the previous prospect's email into a new Gmail draft.",
          attributes: [
            {
              name: "app.Gmail.duration_s",
              value: 25.0,
            },
            {
              name: "screenshots",
              value: ["2026-07-29_09_08_12_000.png", "2026-07-29_09_08_26_000.png"],
            },
          ],
          relationships: [
            {
              object: "Prospect C outreach email",
              qualifier: "copied-to-new-draft",
            },
          ],
          coverage: [["2026-07-29T09:08:05Z", "2026-07-29T09:08:30Z"]],
          duration_s: 25.0,
        },
        {
          id: 5012,
          depth: 2,
          name: "recheck-role-and-context",
          goal: "Return to LinkedIn to recheck Prospect B's executive seniority, responsibilities, and company context before adapting the copied email.",
          attributes: [
            {
              name: "app.LinkedIn.duration_s",
              value: 55.0,
            },
            {
              name: "screenshots",
              value: ["2026-07-29_09_08_39_000.png", "2026-07-29_09_09_16_000.png"],
            },
          ],
          relationships: [
            {
              object: "Prospect B",
              qualifier: "seniority-rechecked",
            },
            {
              object: "Company Beta",
              qualifier: "context-rechecked",
            },
          ],
          coverage: [["2026-07-29T09:08:30Z", "2026-07-29T09:09:25Z"]],
          duration_s: 55.0,
        },
        {
          id: 5013,
          depth: 2,
          name: "rewrite-outreach-for-seniority",
          goal: "Rewrite the value proposition, customer examples, and call to action because the source email targeted an Operations Manager rather than a VP Operations.",
          attributes: [
            {
              name: "app.Gmail.duration_s",
              value: 120.0,
            },
            {
              name: "screenshots",
              value: [
                "2026-07-29_09_09_39_000.png",
                "2026-07-29_09_10_18_000.png",
                "2026-07-29_09_10_57_000.png",
                "2026-07-29_09_11_19_000.png",
              ],
            },
          ],
          relationships: [
            {
              object: "VP Operations value proposition",
              qualifier: "rewritten",
            },
            {
              object: "Executive-level call to action",
              qualifier: "rewritten",
            },
          ],
          coverage: [["2026-07-29T09:09:25Z", "2026-07-29T09:11:25Z"]],
          duration_s: 120.0,
        },
        {
          id: 5014,
          depth: 2,
          name: "research-company-website",
          goal: "Open Company Beta's website and find a recent announcement about a new EMEA fulfillment center to add a more specific outreach detail.",
          attributes: [
            {
              name: "app.Google Chrome.duration_s",
              value: 65.0,
            },
            {
              name: "screenshots",
              value: [
                "2026-07-29_09_11_34_000.png",
                "2026-07-29_09_12_03_000.png",
                "2026-07-29_09_12_24_000.png",
              ],
            },
          ],
          relationships: [
            {
              object: "Company Beta website",
              qualifier: "researched",
            },
            {
              object: "EMEA fulfillment center announcement",
              qualifier: "selected-as-context",
            },
          ],
          coverage: [["2026-07-29T09:11:25Z", "2026-07-29T09:12:30Z"]],
          duration_s: 65.0,
        },
        {
          id: 5015,
          depth: 2,
          name: "rewrite-email-paragraphs",
          goal: "Return to Gmail and rewrite the opening and value-proposition paragraphs using the additional company detail.",
          attributes: [
            {
              name: "app.Gmail.duration_s",
              value: 55.0,
            },
            {
              name: "screenshots",
              value: ["2026-07-29_09_12_41_000.png", "2026-07-29_09_13_17_000.png"],
            },
          ],
          relationships: [
            {
              object: "Company Beta outreach draft",
              qualifier: "rewritten",
            },
          ],
          coverage: [["2026-07-29T09:12:30Z", "2026-07-29T09:13:25Z"]],
          duration_s: 55.0,
        },
        {
          id: 5016,
          depth: 2,
          name: "recover-previous-phrasing",
          goal: "Reopen the previous email to recover a useful formulation, then return to the new draft.",
          attributes: [
            {
              name: "app.Gmail.duration_s",
              value: 25.0,
            },
            {
              name: "screenshots",
              value: ["2026-07-29_09_13_31_000.png", "2026-07-29_09_13_45_000.png"],
            },
          ],
          relationships: [
            {
              object: "Prospect C outreach email",
              qualifier: "reopened-for-phrasing",
            },
          ],
          coverage: [["2026-07-29T09:13:25Z", "2026-07-29T09:13:50Z"]],
          duration_s: 25.0,
        },
        {
          id: 5017,
          depth: 2,
          name: "correct-and-send-email",
          goal: "Reread the draft, remove the old prospect name, company, and manager-level wording left from the copied email, then send the corrected email to Prospect B.",
          attributes: [
            {
              name: "app.Gmail.duration_s",
              value: 40.0,
            },
            {
              name: "screenshots",
              value: [
                "2026-07-29_09_13_58_000.png",
                "2026-07-29_09_14_18_000.png",
                "2026-07-29_09_14_27_000.png",
              ],
            },
          ],
          relationships: [
            {
              object: "Prospect C",
              qualifier: "stale-reference-removed",
            },
            {
              object: "Company Gamma",
              qualifier: "stale-reference-removed",
            },
            {
              object: "Prospect B",
              qualifier: "emailed",
            },
          ],
          coverage: [["2026-07-29T09:13:50Z", "2026-07-29T09:14:30Z"]],
          duration_s: 40.0,
        },
        {
          id: 6001,
          depth: 3,
          name: "Qualify Assigned Lead",
          goal: "Review Lead A in Salesforce and verify role, seniority, and company context on LinkedIn.",
          duration_s: 90.0,
          children: [5001, 5002],
        },
        {
          id: 6002,
          depth: 3,
          name: "Create First Outreach from Playbook",
          goal: "Use the 'VP Operations — first outreach' template and personalize only the prospect name, company, and one context sentence.",
          duration_s: 145.0,
          children: [5003, 5004, 5005, 5006],
        },
        {
          id: 6003,
          depth: 3,
          name: "Review and Send First Outreach",
          goal: "Perform a quick final review and send the standardized first-outreach email.",
          duration_s: 50.0,
          children: [5007],
        },
        {
          id: 6004,
          depth: 3,
          name: "Research Assigned Lead",
          goal: "Review Lead B in Salesforce and research Prospect B and Company Beta on LinkedIn.",
          duration_s: 100.0,
          children: [5008, 5009],
        },
        {
          id: 6005,
          depth: 3,
          name: "Reuse Previous Prospect Email",
          goal: "Search Gmail for an email sent to a different prospect and copy it into a new draft.",
          duration_s: 95.0,
          children: [5010, 5011],
        },
        {
          id: 6006,
          depth: 3,
          name: "Adapt Outreach for Different Seniority",
          goal: "Recheck the target role and rewrite the value proposition, examples, and call to action for VP-level seniority.",
          duration_s: 175.0,
          children: [5012, 5013],
        },
        {
          id: 6007,
          depth: 3,
          name: "Enrich Context and Rework Draft",
          goal: "Research the company website, rewrite multiple paragraphs, and reopen the old email to recover wording.",
          duration_s: 145.0,
          children: [5014, 5015, 5016],
        },
        {
          id: 6008,
          depth: 3,
          name: "Correct Copied Remnants and Send",
          goal: "Remove references left from the previous prospect, perform a final review, and send the email.",
          duration_s: 40.0,
          children: [5017],
        },
        {
          id: 7001,
          depth: 4,
          name: "Outbound Pipeline Generation",
          goal: "Process A — Create and send a personalized first-outreach email in 4 minutes 45 seconds using a role-specific playbook template.",
          duration_s: 285.0,
          children: [6001, 6002, 6003],
        },
        {
          id: 7002,
          depth: 4,
          name: "Outbound Pipeline Generation",
          goal: "Process B — Create and send a personalized first-outreach email in 9 minutes 15 seconds by copying and repeatedly rewriting a previous prospect's email.",
          duration_s: 555.0,
          children: [6004, 6005, 6006, 6007, 6008],
        },
      ],
      orphans: [
        {
          id: 5101,
          depth: 2,
          name: "navigate-to-next-lead",
          goal: "Close the first sent email and switch back to Salesforce to begin the next lead.",
          attributes: [
            {
              name: "app.Gmail.duration_s",
              value: 12.0,
            },
            {
              name: "app.Salesforce.duration_s",
              value: 18.0,
            },
            {
              name: "screenshots",
              value: ["2026-07-29_09_04_52_000.png", "2026-07-29_09_05_09_000.png"],
            },
          ],
          coverage: [["2026-07-29T09:04:45Z", "2026-07-29T09:05:15Z"]],
          duration_s: 30.0,
        },
      ],
    },
  },
  include_in_processes: true,
};
